import React from 'react';
import PackageEditorPage from '../packages-v2/editor-page/PackageEditorPage';

// NOTE: `PackageForm` is kept for backwards-compatibility.
// The UX is now powered by the V2 page editor (matching the Add-ons V2 vibe, but as a page).
const PackageForm = ({ open, onClose, serviceId, packageItem, onSave }) => {
  return (
    <PackageEditorPage
      open={open}
      serviceId={serviceId}
      packageItem={packageItem}
      busy={false}
      onClose={onClose}
      onSave={onSave}
    />
  );
};

export default PackageForm;